import React, { useEffect } from 'react';
import './DownloadedElement.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { urls } from '../router/urls';
import ReactTooltip from 'react-tooltip';

const DownloadedElement = ({ nombre, description, id, deleteObject, type }) => {
  const accordion_item = '#js_list_accordion-' + id;
  const accordion_item_id = 'js_list_accordion-' + id;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [i18n]);

  return (
    <div className="card border-top-left-radius-0 border-top-right-radius-0">
      <ReactTooltip />
      <div className="card-header">
        <button
          className="card-title collapsed"
          data-toggle="collapse"
          data-target={accordion_item}
          aria-expanded="false"
          data-filter-tags={nombre}
        >
          {nombre}
          <span className="ml-auto">
            <span className="collapsed-reveal">
              <i className="fal fa-chevron-up fs-xl"> </i>
            </span>
            <span className="collapsed-hidden">
              <i className="fal fa-chevron-down fs-xl"> </i>
            </span>
          </span>
        </button>
      </div>

      <div
        id={accordion_item_id}
        className="collapse"
        data-parent="#js_list_accordion"
        style={{}}
      >
        <div className="card-body">
          <div className="p-3">
            <div className="text-over">{description}</div>
            <div className="demo float-right">
              <Link
                to={
                  type === 'group'
                    ? `${urls.descargas_agrupaciones}/${id}`
                    : `${urls.descargas_recursos}/${id}`
                }
                className="btn btn-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
                style={{ color: 'rgb(68, 68, 68) !important' }}
                data-tip={t('info')}
              >
                <span className="fal fa-info"> </span>
              </Link>
              <button
                className="btn btn-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
                data-tip={t('borrar')}
                onClick={deleteObject}
              >
                <span className="fal fa-trash-alt"> </span>{' '}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadedElement;
